import { useState } from "react";
import { addDoc, collection, serverTimestamp } from "firebase/firestore";
import { db } from "../firebase-config";

export default function HomePage() {
  const [email, setEmail] = useState("");
  const [isSubscribed, setIsSubscribed] = useState(false);

  const handleSubscribe = async () => {
    try {
      await addDoc(collection(db, "subscribers"), {
        email: email,
        timestamp: serverTimestamp(),
      });
      setIsSubscribed(true);
    } catch (error) {
      console.error("Error adding subscriber: ", error);
    }
  };

  return (
    <main>
      <div className="line-top line-bottom text-small text-center">
        <div className="main-inner">
          <div style={{ marginTop: "4.0rem" }}>
            <p
              className="text-lower"
              style={{
                marginTop: "6.0rem",
                marginBottom: "6.5rem",
                fontSize: "1.2rem",
              }}
            >
              Matt Bongiovi is actually a really private person, and it would be
              great if you could just respect that.
            </p>
          </div>

          <div className="row-bottom line-top">
            <div
              className="newsletter-signup"
              style={{ alignContent: "center" }}
            >
              <p style={{ marginBottom: "1.5rem" }}>
                Keep up with the latest Matt Bongiovi news and updates.
              </p>
              {!isSubscribed ? (
                <div
                  className="email-input-container"
                  style={{
                    display: "flex",
                    gap: "1rem",
                    alignContent: "center",
                    justifyContent: "center",
                  }}
                >
                  <input
                    type="email"
                    placeholder="Enter your email"
                    className="email-input"
                    style={{ flex: "3", height: "40px", maxWidth: "300px" }}
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                  />
                  <button
                    className="cta"
                    style={{
                      flex: "1",
                      height: "40px",
                      fontSize: "1.2rem",
                      alignSelf: "center",
                      maxWidth: "120px",
                    }}
                    disabled={!email}
                    onClick={handleSubscribe}
                  >
                    Subscribe
                  </button>
                </div>
              ) : (
                <p style={{ marginBottom: "1.5rem" }}>
                  Thanks for subscribing! If Matt Bongiovi does something
                  interesting, we'll make sure you're the first to know.
                </p>
              )}
            </div>

            <div className="social-media-links" style={{ marginTop: "2rem" }}>
              <a
                href="https://bsky.app/profile/bongiovimatt.bsky.social"
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  color: "#0066cc",
                  textDecoration: "none",
                  fontSize: "1.1rem",
                }}
              >
                Follow Matt Bongiovi on Bluesky
              </a>
            </div>
          </div>
        </div>
      </div>
    </main>
  );
}
